import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ToolCategoryBuilder } from '../../models/builders/tool-category.builder';
import { getErrorHandlingOptions } from '../base/headers';
import { ToolCategory } from '../../models/tool-category';

const toolCategoryBody = (toolCategory: ToolCategory) => ({
  name: toolCategory.name
});

@Injectable()
export class ToolCategoryApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }toolCategories`;
  }

  getToolCategories() {
    return this.httpClient.get(`${ this.apiUrl }`, getErrorHandlingOptions())
      .pipe(
        map(ToolCategoryBuilder.fromList)
      );
  }

  getToolCategory(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
      .pipe(
        map(ToolCategoryBuilder.fromJson)
      );
  }

  createToolCategory(toolCategory) {
    return this.httpClient.post(this.apiUrl, toolCategoryBody(toolCategory)).pipe(map(ToolCategoryBuilder.fromJson));
  }

  updateToolCategory(toolCategory: ToolCategory) {
    return this.httpClient.put(`${ this.apiUrl }/${ toolCategory.hash }`, toolCategoryBody(toolCategory));
  }

  deleteToolCategory(toolCategory: ToolCategory) {
    return this.httpClient.delete(`${ this.apiUrl }/${ toolCategory.hash }`);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/tool-category-api.service.ts